import { IconDashboard, IconLightning } from '@paretogroup/tess';

export const IntegrationTagsIcons = {
    Reports: IconDashboard,
    'Tess Automations': IconLightning,
};
